{
  "customer-request-online-booking-dialog": {
    "buttons": {
      "submit": "XÁC NHẬN"
    },
    "text": {
      "title": "Yêu cầu đặt lịch trực tuyến",
      "email": "E-mail của bạn",
      "hint": "Tiệm chưa cung cấp dịch vụ đặt lịch hẹn trực tuyến. Để lại email của bạn và chúng tôi sẽ thông báo cho bạn khi tính năng đặt lịch hẹn trực tuyến được kích hoạt cho tiệm trong tương lai",
      "request-sent-success": "Yêu cầu của bạn đã được gửi thành công!"
    }
  }
}
